import styled from 'styled-components';
import { IfDocSrchRes } from '../models/IfDocSrch';

type Props = {
  list: IfDocSrchRes[];
  selId: number | null;
  onSelect(item: IfDocSrchRes): void;
};
export const DocList = (props: Props) => {
  const { list } = props;
  return (
    <Body>
      {list?.map((item) => (
        <Item key={item.id} onClick={() => props.onSelect(item)} className={props.selId === item.id ? 'sel' : ''}>
          {item.docTitle}
        </Item>
      ))}
    </Body>
  );
};

const Item = styled.div`
  padding: 0.2rem 0.6rem;
  cursor: pointer;
  border-radius: 0.4rem;

  &:hover {
    background-color: #f0f0f0;
  }

  &.sel {
    background-color: #f0f0f0;
  }
`;
const Body = styled.div`
  font-size: 1.4rem;
  line-height: 2.4rem;
  overflow-y: auto;
  overscroll-behavior-y: contain;
`;
